import React from 'react';
import cn from 'classnames';

export default ({ children, className }) => {
  return <p className={ cn('wide', className) }>{children}</p>
}


// WEBPACK FOOTER //
// ./src/components/common/WideP.js